import { Button, Stack } from '@mui/material'
import React from 'react'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import LinkWrapper from '../common/LinkWrapper'

interface TableCaptionProps {
    link: string
}

const TableCaption: React.FC<TableCaptionProps> = ({ link }: TableCaptionProps) => {
    return (
        <caption>
            <Stack direction='row' justifyContent='flex-end'>
                <LinkWrapper route={link}>
                    <Button>
                        Vše
                        <ArrowForwardIcon />
                    </Button>
                </LinkWrapper>
            </Stack>
        </caption>
    )
}

export default TableCaption
